import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DevoteeDetail } from '../../../Devotee/devotee-detail';
import { SharedService } from '../../../shared/shared.service';
import { AdminDevoteeService } from '../../services/admin-devotee.service';

@Component({
  selector: 'app-admin-devotee-address-print',
  templateUrl: './admin-devotee-address-print.component.html',
  styleUrls: ['./admin-devotee-address-print.component.css'],
  providers: [AdminDevoteeService]
})
export class AdminDevoteeAddressPrintComponent implements OnInit {

  constructor(private sharedService: SharedService,
    private adminDevoteeService: AdminDevoteeService,
    private formBuilder: FormBuilder) { }


  devoteeList: DevoteeDetail[] = [];
  totalPage: number;
  errorMessage: string = "";
  searchForm: FormGroup;

  ngOnInit() {
    this.createSearchForm();
   // this.loadKiteData();
  }

  loadKiteData() {

    this.sharedService.showSpinner();
    this.adminDevoteeService.loadKiteData().subscribe(
      data => {
        console.log(data);
      },
      err => this.errorMessage = err,
      () => this.sharedService.hideSpinner()
    )

  }


  devoteeSearch() {

    let searchGridEntity = this.searchForm.value;

    this.sharedService.showSpinner();
    this.adminDevoteeService.searchAdminDevoteeAddPrint(searchGridEntity).subscribe(
      data => {
        console.log(data);
        this.devoteeList = data;
      },
      err => this.errorMessage = err,
      () => this.sharedService.hideSpinner()
    )

  }

  createSearchForm(): void {
    this.searchForm = this.formBuilder.group({
      IncludeYear: [],
      ExcludeYear: [],
      AmountFrom: [],
      AmountTo: [],
      State: [],
      NewDevotee:[]
    });
  }

  
  print(): void {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=700,width=1000');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>        

          <style>
          
          body {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
    font-size: 14px;
    line-height: 1.42857143;
    color: #333;
    background-color: #fff;
    margin: 0;
}

address {
    margin-bottom: 20px;
    font-style: normal;
    line-height: 1.42857143;
}

* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}


.barcode { font-family: "Free 3 of 9";font-size: 32px }

.addressbox{
    padding-top: 5px;
    padding-left: 10px;  
    height: 1.55in; 
    overflow: hidden;
    /*color:#885f07;*/
}

.boxlabel{
        /* Avery 5160 labels -- CSS and HTML by MM at Boulder Information Services */
        width: 2.51in; /* plus .6 inches from padding */
        height: 2in; /*.875in; /* plus .125 inches from padding */
        padding: 2px .1in 0;
        margin-right: .125in; /* the gutter */
        margin-bottom: 10px;
        font-size: 13px;
        float: left;
        /*text-align: center;*/
        overflow: hidden;
        outline: 1px auto; /*outline doesn't occupy space like border does border-bottom: 1px dotted */
        outline-width: 1px;
        outline-style: inset;
        color: black;
      }
      
      .pagebody {
        width: 8.5in;            
        margin-left: 10px;
        }
      
    .page-break  {
        clear: left;
        display:block;
        page-break-after:always;
    }

    .boxlabel:nth-child(15n+1){
            margin-top: 50px;
        }
        .boxlabel:nth-child(15n+2) {
            margin-top: 50px;
        }
        .boxlabel:nth-child(15n+3){
            margin-top: 50px;
        }
          </style>         
       
        </head>
    <body>${printContents}</body>
      </html>`
    );
    popupWin.document.close();
  }



}



// WEBPACK FOOTER //
// ./src/app/admin/components/admin-devotee-address-print/admin-devotee-address-print.component.ts